/* eslint-disable react/no-danger, react/display-name */
import AtomicBlockIdentifiers from "../AtomicBlockIdentifiers";
import EntityTypeIdentifiers from "../EntityTypeIdentifiers";
import React from "react";
import { convertToHTML } from "draft-convert";

/**
 * @type {Function}
 */
const translateIntoHtmlString = convertToHTML({
  /**
   * @param   {Object} block
   * @returns {?ReactElement}
   */
  blockToHTML: block => {
    if (block.type === "atomic") {
      if (block.data.blockType === AtomicBlockIdentifiers.IMAGE) {
        return <img src={block.data.imageUrl} alt={block.data.imageUrl} />;
      }

      if (block.data.blockType === AtomicBlockIdentifiers.YOUTUBE_VIDEO) {
        return <a href={block.data.videoUrl}>{block.data.videoUrl}</a>;
      }

      if (block.data.blockType === AtomicBlockIdentifiers.DIVIDER) {
        return <hr />;
      }
    }

    return null;
  },

  /**
   * @param   {String} style
   * @returns {?ReactElement}
   */
  styleToHTML: style => {
    if (style === "HIGHLIGHT") {
      return <mark />;
    }

    return null;
  },

  /**
   * @param {Object} entity
   * @param {String} originalText
   * @returns {?ReactElement}
   */
  entityToHTML: (entity, originalText) => {
    if (entity.type === EntityTypeIdentifiers.LINK) {
      return (
        <a href={entity.data.url} target="_blank" title={entity.data.url} rel="noopener noreferrer">
          {originalText}
        </a>
      );
    }

    if (entity.type === EntityTypeIdentifiers.MENTION) {
      const jsonChildren = JSON.stringify({
        type: entity.data.getType(),
        metadata: entity.data.getMetadata(),
        mutability: entity.data.getMutability(),
        displayText: entity.data.getDisplayText(),
        entityType: EntityTypeIdentifiers.MENTION,
      });

      return <span>{jsonChildren}</span>;
    }

    return null;
  },
});

export default translateIntoHtmlString;
